/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Scope_Detail5Inputs */

const en_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target analysis, structure, protections, rate limits, and consent.`)
};

const ar_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل الهدف, البنية والحمايات وحدود المعدل والموافقة.`)
};

const bn_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টার্গেট অ্যানালাইসিস, স্ট্রাকচার, প্রোটেকশন, রেট লিমিট ও কনসেন্ট।`)
};

const de_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielanalyse, Struktur, Schutzmaßnahmen, Ratenbeschränkungen und Einwilligung.`)
};

const es_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de objetivos, estructura, protecciones, rate limits y consentimiento.`)
};

const fr_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse cible, structure, protections, limites de débit et consentement.`)
};

const pt_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de alvo, estrutura, proteções, rate limits e consentimento.`)
};

const zh_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标分析、结构、保护、速率限制和同意。`)
};

const tr_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hedef analizi, yapı, korumalar, rate limit'ler ve onay.`)
};

const ru_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой анализ, структура, защита, ограничения скорости и согласие.`)
};

const pl_svc_web_scraping_scope_detail5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza celu, struktura, zabezpieczenia, limity i zgoda.`)
};

/**
* | output |
* | --- |
* | "Target analysis, structure, protections, rate limits, and consent." |
*
* @param {Svc_Web_Scraping_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_scope_detail5 = /** @type {((inputs?: Svc_Web_Scraping_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_web_scraping_scope_detail5(inputs)
	if (locale === "de") return de_svc_web_scraping_scope_detail5(inputs)
	if (locale === "es") return es_svc_web_scraping_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_web_scraping_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_web_scraping_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_web_scraping_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_web_scraping_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_web_scraping_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_web_scraping_scope_detail5(inputs)
	return en_svc_web_scraping_scope_detail5(inputs)
});
export { svc_web_scraping_scope_detail5 as "svc_web-scraping_SCOPE_detail" }